"use client"

import { useEffect } from "react"
import { ContentfulLivePreview } from "@contentful/live-preview"

// Subscribes to Contentful save events so we can revalidate the current page while in preview mode.
export function ContentfulLiveUpdatesBridge() {
    useEffect(() => {
        const handler = async () => {
            try {
                const pathname = window.location.pathname || "/"
                const url = new URL("/api/revalidate", window.location.origin)
                url.searchParams.set("pathname", pathname)
                const response = await fetch(url.toString(), {
                    method: "GET",
                    credentials: "include",
                })
                if (!response.ok) {
                    console.error("Failed to revalidate path", await response.text())
                    return
                }
                window.location.reload()
            } catch (error) {
                console.error("Failed to trigger revalidation", error)
            }
        }

        const subscription = ContentfulLivePreview.subscribe("save", {
            callback: handler,
        })

        return () => {
            subscription?.()
        }
    }, [])

    return null
}
